
import { CreatePartnerApplicationInput } from '@/types/generated/graphql'
import Vue from 'vue'
import { Step } from '../PartnerSignup.vue'

type Props = {
  input: CreatePartnerApplicationInput & { storeCount: number }
  onNext: (step: Step) => void
  onSubmit: () => void
}

export default Vue.extend<{}, {}, {}, Props>({
  props: {
    input: {
      type: Object,
    },
    onNext: {
      type: Function,
    },
    onSubmit: {
      type: Function,
    },
  },
})
